import { useParams } from 'react-router-dom'
import { match } from 'ts-pattern'
import { useUnenrollmentRouteContext } from '..'
import frown from '@/app/img/frown.svg'
import { Button, Icon, Text } from '@/components'
import { useNavigation } from '@/app/hooks'
type UnenrollmentStates = 'success' | 'error'
export default function UnenrollState() {
  const params = useParams<{ state: UnenrollmentStates }>()
  const { utilityProgram } = useUnenrollmentRouteContext()
  const navigate = useNavigation()

  const backToProgramsClick = () => {
    navigate.push('/devices')
  }
  const tryAgainClick = () => {
    navigate.push(`/utility-program/${utilityProgram.id}/program-details`)
  }
  return (
    <div className="flex flex-col gap-4 h-full w-full items-center justify-center">
      {match(params.state)
        .with('success', () => (
          <div className="flex flex-col gap-20">
            <section className="flex flex-col justify-center gap-4 items-center h-full">
              <Icon name="FormValid" size={50} />
              <Text variant="h2" className="text-center">
                Your devices were successfully unenrolled from the{' '}
                {utilityProgram.view_config_json.name ?? ''} program
              </Text>
            </section>
            <Button
              id="unenroll-success-back-to-programs"
              onClick={backToProgramsClick}
            >
              Back to programs
            </Button>
          </div>
        ))
        .with('error', () => (
          <div className="flex flex-col gap-20">
            <section className="flex flex-col justify-center gap-4 items-center h-full">
              <img className="w-10 h-10" src={frown} alt="Red frown face" />
              <Text variant="h2" className="text-center">
                Oh no! We couldn't enroll you from the{' '}
                {utilityProgram.view_config_json.name ?? ''} program
              </Text>
              <Text variant="h3-subheader" className="text-center">
                Please try again later or contact support at{' '}
                <a href="mailto:support@optiwatt.com">support@optiwatt.com</a>
              </Text>
            </section>
            <Button id="unenroll-error-try-again" onClick={tryAgainClick}>
              Try again
            </Button>
          </div>
        ))
        .exhaustive()}
    </div>
  )
}
